<template>
  <MatchMedia query="(max-width: 768px)" v-slot="{ matches }">
    <WinerySocialMediaMobile  v-if="matches" />
    <WinerySocialMediaDesktop v-else />
  </MatchMedia>
</template>
 
<script>
  import { MatchMedia } from "vue-component-media-queries";
  import WinerySocialMediaMobile from "./WinerySocialMedia_Mobile.vue";
  import WinerySocialMediaDesktop from "./WinerySocialMedia_Desktop.vue";
 
  export default {
    name: 'WinerySocialMedia',
    components: {
      MatchMedia,
      WinerySocialMediaMobile,
      WinerySocialMediaDesktop,
    },
  }
</script> 